<template>
    <div class="comment__body">
        <form>
            <textarea v-model="$v.commentForm.text.$model"  placeholder="Оставьте комментарий"></textarea>
            <div class="field-error-text" v-if="$v.commentForm.text.$error">Введите комментарий.</div>
            <div class="field-error-text" v-if="$v.commentForm.commentable_id.$error || $v.commentForm.commentable_type.$error || $v.commentForm.reply_comment_id.$error">Ошибка! Повторите попытку позже.</div>
            <button class="btn btn--sm btn--round" type="submit" :disabled="$v.commentForm.$invalid" @click.prevent="sendComment()">Отправить</button>
        </form>
    </div>
</template>

<script>

import { required, minLength, requiredIf } from 'vuelidate/lib/validators';

export default {
    name: "PetAndProjectCommentForm",
    props: ['type', 'object', 'reply'],
    data(){
        return{
            commentForm: {
                commentable_type: this.type,
                commentable_id: this.object.id,
                reply_comment_id: this.reply,
                text: null,
            },
        }
    },

    methods: {
        async sendComment(){

            this.$v.commentForm.$touch();
            if (this.$v.commentForm.$invalid) {
                return false;
            }

            let params = {
                commentable_type: this.commentForm.commentable_type,
                commentable_id: this.commentForm.commentable_id,
                reply_comment_id: this.commentForm.reply_comment_id,
                text: this.commentForm.text,
            };

            try{

                const { data: { success } = { success: false } /*default data*/ } = await axios.post( '/api/comments', params );

                if( success ) {

                    this.$emit('refresh-comments');

                    this.commentForm = Object.assign( {}, this.commentForm, { text: null, reply_comment_id: this.reply || null } );

                    this.$v.commentForm.$reset();

                }


            } catch ( _e ){

                console.log( _e );

            }

        },
    },

    validations:{

        commentForm: {
            commentable_type: {
                required,
                type(val){
                    return val === this.type
                }
            },

            commentable_id: {
                required,
                id(val){
                    return this.object && this.object.id && +val === +this.object.id
                }
            },

            reply_comment_id: {
                required: requiredIf(function (){
                    return this.reply
                })
            },

            text: {
                required,
            }
        }

    }

}
</script>

<style lang="scss" scoped>

.comment{

    &__body{
        margin-top: 15px;

        .btn{
            display: block;
            margin-left: auto;
            width: intrinsic;           /* Safari/WebKit используют нестандартное имя */
            width: -moz-max-content;    /* Firefox/Gecko */
            width: -webkit-max-content; /* Chrome */
        }

    }

    @media screen and (max-width: 768px){

        &__body{
            margin: 15px 0;
            .btn{
                margin: 0 auto;
            }

        }

    }


}

</style>
